import DOMPurify from 'dompurify';

/**
 * Sanitize HTML produced from user markdown before injecting into the DOM.
 * Strips script tags, event handlers, and other XSS vectors while keeping
 * common markdown output (paragraphs, links, emphasis, code).
 */
export function sanitizeMarkdownHtml(html: string): string {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
